import { ViewSupport45Container } from "../../../containers/SupportSystem/ViewReports/ViewSupport45Container"
export function ViewSupport45Page() {
    return (
        <ViewSupport45Container />
    )
}